class WiroModule {
  constructor(name, parentEl) {
    this.name = name || "wiroModule";
    this.parentEl = parentEl;
  }

  bindEvents() { }
  unbindEvents() { }
  render() { }

}

class WiroModuleHandler extends HTMLElement {
  /**
   * @param {WiroModule[]} modules
   */
  constructor(modules) {
    super();

    this.modules = {};
    for (const Module of modules) {
      const newModule = new Module(this);
      this.modules[newModule.name] = newModule;
    }
  }

  connectedCallback() {
    Object.values(this.modules).forEach((module) => module.bindEvents());
  }

  disconnectedCallback() {
    Object.values(this.modules).forEach((module) => module.unbindEvents());
  }
}

class WiroHTMLRenderer extends WiroModuleHandler {
  /**
   * @param {WiroModule[]} modules
   */
  constructor(modules = []) {
    super(modules);
  }

  connectedCallback() {
    super.connectedCallback();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  prepareStringForRender(string) {
    if (!string) return;
    const domParser = new DOMParser();
    const dom = domParser.parseFromString(string, "text/html");
    return dom.body.firstChild;
  }

  render(dom) {
    if (!dom) return;
    if (typeof dom === "string") dom = this.prepareStringForRender(dom);
    this.innerHTML = "";
    this.appendChild(dom);
    Object.values(this.modules).forEach((module) => module.render());
  }
}

class WiroCartModule extends WiroModule {
  constructor(parentEl) {
    super("cart", parentEl);
    this._isFetching = false;
    this.root = window.Shopify.routes.root || "/";
  }

  get isFetching() {
    return this._isFetching;
  }

  set isFetching(value) {
    this._isFetching = value;
    const event = new CustomEvent("cart:fetching", {
      detail: { isFetching: value },
      bubbles: true,
    });
    document.dispatchEvent(event);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id
      }
    ]
  }

  renderCartSections(responseData) {
    const domParser = new DOMParser();
    this.getSectionsToRender().forEach(({ id, section }) => {
      const target = document.getElementById(id);
      const html = responseData?.sections?.[section];
      if (!target || !html) return;

      const parsed = domParser.parseFromString(html, "text/html");
      const replacement = parsed.getElementById(id) || parsed.body.firstElementChild;
      if (!replacement) return;

      target.replaceWith(replacement);
    });
    this._updateCartCount()
    this._initCountdown()
  
  }

  _updateCartCount() {
    const cartEl = document.getElementById('main-cart-items')
    const counterEl = document.querySelector('[data-cart-count]')
    if (!cartEl || !counterEl) return
    const cartCount = Number(cartEl.getAttribute('cart-count')) || 0
    counterEl.textContent = cartCount
  }

_initCountdown() {
 document.querySelectorAll("[cart-data-countdown]").forEach((countdown) => {
  const countdownDate = countdown.getAttribute("cart-data-countdown");

  if (!countdownDate) return;

  const endDate = new Date(
    countdownDate.replace(" ", "T"),
  ).getTime();

  if (Number.isNaN(endDate)) return;

  let countdownInterval;

  const updateCountdown = () => {
    const remainingTime = endDate - Date.now();

    if (remainingTime <= 0) {
      countdown.textContent = "0h 0m 0s";
      clearInterval(countdownInterval);
      return;
    }

    const hours = Math.floor(
      remainingTime / (1000 * 60 * 60),
    );

    const minutes = Math.floor(
      (remainingTime % (1000 * 60 * 60)) / (1000 * 60),
    );

    const seconds = Math.floor(
      (remainingTime % (1000 * 60)) / 1000,
    );

    countdown.textContent = `${hours}h ${minutes}m ${seconds}s`;
  };

  updateCountdown();

  countdownInterval = setInterval(
    updateCountdown,
    1000,
  );
});
}
  _normalizeAttributeName(name) {
    return name
      .replace(/^attributes\[/, '')
      .replace(/\]$/, '')
  }

  fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
    };
  }

  async changeCartItem(line, quantity, selling_plan) {
    this.isFetching = true;

    const body = JSON.stringify({
      line,
      quantity,
      ...(selling_plan !== undefined ? { selling_plan } : {}),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${this.root}cart/change`, { ...this.fetchConfig(), ...{ body } })
      if (!response.ok) {
        throw new Error(`Failed to fetch cart: ${response.status}`);
      }
      this.renderCartSections(await response.json());
    } catch (error) {
      console.error(error);
      return null;
    } finally {
      this.isFetching = false;
    }
  }

  confirmSurchargePopover(festiveDate, popoverId = 'date-confirm') {
    return new Promise((resolve) => {
      const popover = document.getElementById(popoverId);
      if (!popover) {
        resolve(true);
        return;
      }

      let resolved = false;
      const confirmAgree = popover.querySelector('[date-confirm-agree]');

      const onConfirm = () => {
        resolved = true;
        cleanup();
        resolve(true);
      };

      const onToggle = (event) => {
        if (event.newState === 'closed' && !resolved) {
          cleanup();
          resolve(false);
        }
      };

      const cleanup = () => {
        popover.hidePopover();
        confirmAgree?.removeEventListener('click', onConfirm);
        popover.removeEventListener('toggle', onToggle);
      };

      confirmAgree?.addEventListener('click', onConfirm);

      const { delivery_terms } = festiveDate || {};
      const dateReadable = Utility.formatDateToReadable(
        festiveDate.selectedDate || festiveDate.dates
      );
      const selectedDateEl = popover.querySelector('[data-selected-date]');
      if (selectedDateEl) {
        selectedDateEl.textContent = dateReadable;
      }

      const titleEl = popover.querySelector('[festive-title]');
      if (titleEl) {
        titleEl.textContent = delivery_terms.title;
      }

      const termsEl = popover.querySelector('[festive-terms]');
      if (termsEl) {
        termsEl.innerHTML = delivery_terms.content;
      }

      popover.addEventListener('toggle', onToggle);
      popover.showPopover();
    });
  }

  _resetDeliveryDate() {
    const datePicker = document.querySelector('date-picker');
    datePicker?.resetDatepicker();
  }

  async updateDelivery(dateStr, festiveDays) {
    if (!dateStr || !festiveDays) return;
    this.isFetching = true;
    dayjs.extend(window.dayjs_plugin_customParseFormat);
    const date = dayjs(dateStr, "DD/MM/YYYY");
    if (!date.isValid()) return;
    const surchargeProduct = window.surchargeProduct || {};
    const surchargeVariantId = surchargeProduct.variants ? surchargeProduct.variants[0].id : null;
    let surcharges = {};
    surchargeVariantId && (surcharges[surchargeVariantId] = 0);
    const festiveDate = festiveDays.find((date) => {
      return date.dates.includes(dateStr);
    });
    const surcharge = festiveDate && festiveDate.surcharge ? festiveDate.surcharge.variant_id : 0;

    if (Object.keys(surchargeProduct).length > 0) {
      festiveDays.map((date) => {
        if (date.surcharge) {
          surcharges[date.surcharge.variant_id] = 0;
        }
      });
    }

    if (surcharge !== 0) {
      surcharges[surcharge] = 1;
    }

    try {
      // Update delivery date & surcharges
      const response = await fetch(`${this.root}cart/update`, {
        ...this.fetchConfig(),
        body: JSON.stringify({
          updates: { ...surcharges },
          attributes: {
            "Delivery Date": date.format("DD/MM/YYYY")
          },
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        })
      })
      if (!response.ok) {
        throw new Error(`Failed to update cart: ${response.status}`);
      }

      this.renderCartSections(await response.json());
    } finally {
      this.isFetching = false;
      const confirmed = festiveDate ? await this.confirmSurchargePopover({ ...festiveDate, selectedDate: dateStr }, 'date-confirm') : true;
      if (!confirmed) {
        this.isFetching = false;
        this._resetDeliveryDate();
        return;
      }
    }
  }

  async updateNote(name = 'note', message) {
    this.isFetching = true;
    const payload = {
      sections: this.getSectionsToRender().map(section => section.section),
      sections_url: window.location.pathname,
    }

    if (name === 'note') {
      payload.note = message || ''
    } else {
      const attributeName = this._normalizeAttributeName(name)
      payload.attributes = { [attributeName]: message || '' }
    }
    try {
      const response = await fetch(`${this.root}cart/update`, {
        ...this.fetchConfig(),
        body: JSON.stringify(payload)
      })
      if (!response.ok) {
        throw new Error(`Failed to update cart note: ${response.status}`);
      }
      this.renderCartSections(await response.json());
    } finally {
      this.isFetching = false;
    }
  }
}

class Utility {
  static debounce(func, wait = 300) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  static formatDateToReadable(dateStr, locale = 'en-GB') {
    const [day, month, year] = dateStr.split('/').map(Number);
    const date = new Date(year, month - 1, day);

    const ordinal = (n) => {
      const mod10 = n % 10;
      const mod100 = n % 100;

      if (mod100 >= 11 && mod100 <= 13) return 'th';
      if (mod10 === 1) return 'st';
      if (mod10 === 2) return 'nd';
      if (mod10 === 3) return 'rd';
      return 'th';
    };

    const formatter = new Intl.DateTimeFormat(locale, {
      weekday: 'long',
      month: 'long',
    });

    const [{ value: weekday }, , { value: monthName }] = formatter.formatToParts(date);

    return `${weekday} ${day}${ordinal(day)} ${monthName}`;
  }
}

class CartTracker extends WiroHTMLRenderer {
  static observedAttributes = ["total", "threshold", "empty-text", "inprogress-text", "completed-text"];

  constructor() {
    super([WiroCartModule]);
  }

  connectedCallback() {
    this.render();
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    this.render();
  }

  get threshold() {
    return Number(this.getAttribute("threshold") || 0);
  }

  get total() {
    return Number(this.getAttribute("total") || 0);
  }

  get emptyText() {
    return this.getAttribute("empty-text") || "";
  }

  get inprogressText() {
    return this.getAttribute("inprogress-text") || "";
  }

  get completedText() {
    return this.getAttribute("completed-text") || "";
  }
  get thresholdMessage(){
    return this.getAttribute("thresh-hold-message") || ""
  }

  formatDisplayText(text, total, threshold) {
    const remaining = threshold - total;
    return text
      .replace(/{{\s*money\s*}}/g, theme.Currency.formatMoney(remaining, theme.moneyFormat))
      .replace(/{{\s*min_value\s*}}/g, theme.Currency.formatMoney(threshold, "£{{amount_no_decimals}}"));
  }

  render() {
    const threshold = this.threshold;
    if (!threshold) return;
    const total = this.total;
    const percent = Math.min((total / threshold) * 100, 100);

    const displayedText =
      total === 0
        ? this.emptyText
        : total < threshold
          ? this.inprogressText
          : this.completedText;

    this.innerHTML = `
      <h2>
        ${this.formatDisplayText(displayedText, total, threshold)}
      </h2>
      <div>
      <div class="cart__tracker-progress-wrapper">
        <div class="cart__tracker-progress-bar-background">
        <div class="cart__tracker-progress-bar-amount" style="width:${percent}%">
        </div>
      </div>
      ${window.icons.shipping || ''}
      </div>
      <div>
      ${this.thresholdMessage}
      </div>
    </div>`
  }
}
customElements.define("cart-tracker", CartTracker);

class MainCart extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule])
    this._onCartFetching = this.onCartFetching.bind(this)
    this._onQuickaddFormSubmit = this.onQuickaddFormSubmit.bind(this)
    this._onQuickaddQtyButtonClick = this.onQuickaddQtyButtonClick.bind(this)
    this._onCheckoutButtonClick = this.onCheckoutButtonClick.bind(this)

    this.ageConfirmationButton = document.querySelector('#age-confirm-btn')
    this._onAgeConfirmationButtonClick = this.onAgeConfirmationButtonClick.bind(this)
    this._onContinueShoppingBtnClick = this.onContinueShoppingBtnClick.bind(this)
    this.__onAgePopoverClick = this.onAgePopoverClick.bind(this)
  }

  connectedCallback() {
    document.addEventListener("cart:fetching", this._onCartFetching)
    this.quickAddForms = this.querySelectorAll('form[data-quickadd-form]')
    this.quickAddForms.forEach(form => {
      form.addEventListener('submit', this._onQuickaddFormSubmit)
    })

    this.quickAddQtyBtns = this.querySelectorAll('button.qty-selector__button')
    this.quickAddQtyBtns.forEach(btn => {
      btn.addEventListener('click', this._onQuickaddQtyButtonClick)
    })

    this.checkoutButton = this.querySelector('[button-checkout]')
    this.checkoutButton?.addEventListener('click', this._onCheckoutButtonClick)

    this.ageConfirmationButton?.addEventListener('click', this._onAgeConfirmationButtonClick)

    this.continueShoppingBtn = document.querySelector(".btn-continue--shopping")
    this.continueShoppingBtn?.addEventListener("click", this._onContinueShoppingBtnClick)

    this.agePopover = document.querySelector('#age-check');
    this.agePopover?.addEventListener("click", this.__onAgePopoverClick);

    this.agePopoverCloseBtn = document.querySelector('.cart-popover__close')


    this.agePopoverCloseBtn.addEventListener("click",()=>{
      this.agePopover.classList.remove("is-active")
    })

    this.modules.cart._initCountdown();
  }

  disconnectedCallback() {
    document.removeEventListener("cart:fetching", this._onCartFetching)
    this.quickAddForms.forEach(form => {
      form.removeEventListener('submit', this._onQuickaddFormSubmit)
    })
    this.quickAddQtyBtns.forEach(btn => {
      btn.removeEventListener('click', this._onQuickaddQtyButtonClick)
    })

    this.checkoutButton?.removeEventListener('click', this._onCheckoutButtonClick)
    this.ageConfirmationButton?.removeEventListener('click', this._onAgeConfirmationButtonClick)
    this.continueShoppingBtn?.removeEventListener("click", this._onContinueShoppingBtnClick )


  }

  onCartFetching(event) {
    this.classList.toggle("is-loading", event.detail.isFetching)
    if(this.dataset.showLabel == 'true' && sessionStorage.getItem('showLabel')== 'true'){
      this.classList.add("add-more-label-visible");
    }
    else{
      sessionStorage.removeItem("showLabel");
    }
  }

  async onQuickaddFormSubmit(event) {
    event.preventDefault()
    const form = event.currentTarget || event.target
    const formData = new FormData(form)
    formData.append('sections', this.modules.cart.getSectionsToRender().map(section => section.section).join(','))
    formData.append('sections_url', window.location.pathname)

    this.modules.cart.isFetching = true
    try {
      const response = await fetch(`${this.modules.cart.root}cart/add.js`, {
        method: 'POST',
        body: formData,
      })
      if (!response.ok) {
        throw new Error(`Failed to add to cart: ${response.status}`);
      }
      this.modules.cart.renderCartSections(await response.json());
    } catch (error) {
      console.error(error);
    } finally {
      this.modules.cart.isFetching = false
    }
  }

  onQuickaddQtyButtonClick(event) {
    event.preventDefault()

    const button = event.currentTarget
    const buttonType = button.dataset.quickaddOperatorType
    if (!buttonType) return

    const selectorEl = button.closest('.qty-selector')
    const variantId = selectorEl?.dataset.quickaddSelector
    if (!variantId) return

    const qtyButton = this.querySelector(
      `quantity-input[variant-id="${variantId}"] button[name="${buttonType}"]`
    )

    qtyButton?.click()
  }

  onCheckoutButtonClick(event) {
    event.preventDefault()

    // Date Validation
    const datePickerEl = this.querySelector('date-picker');
    if (!datePickerEl) return;

    const datePickerInput = datePickerEl.querySelector('input');
    if (datePickerInput && datePickerInput.value.length === 0) {
      if (datePickerEl.classList.contains('is-error')) return;
      datePickerEl.classList.add('is-error');
      const errorMessage = document.createElement('p');
      errorMessage.className = 'date-picker__error-message';
      errorMessage.textContent = 'You must select a delivery date';
      datePickerEl.appendChild(errorMessage);
      return;
    }


    // Age Confirmation Check
    const ageCheckbox = this.querySelector('age-confirmation input[type="checkbox"]');
    if (ageCheckbox && !ageCheckbox.checked) {
      this.agePopover.classList.add('is-active');
      return;
    }

    window.location.href = '/checkout';
  }

  onAgePopoverClick(event){
      if (!event.target.closest('.cart-popover--content')) {
        this.agePopover.classList.remove('is-active');
      }
  }
  onAgeConfirmationButtonClick(event) {
    event.preventDefault()
    const ageCheckbox = this.querySelector('age-confirmation input[type="checkbox"]');
    if (ageCheckbox) {
      ageCheckbox.checked = true;
      const changeEvent = new Event('change', { bubbles: true });
      ageCheckbox.dispatchEvent(changeEvent);
    }
    this.modules.cart.isFetching = true
    window.location.href = '/checkout'
  }
  onContinueShoppingBtnClick(){
     const target = document.querySelector('#cart-upsell');

      target?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });

      if (!this.classList.contains("add-more-label-visible")) {
        this.classList.add("add-more-label-visible");
      }

        this.classList.remove("add-more-label-animate");
        void this.offsetWidth;
        this.classList.add("add-more-label-animate");

      sessionStorage.setItem('showLabel', 'true')
  }
}
customElements.define("main-cart", MainCart);

class QuantityInput extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule])
    this.input = this.querySelector("input")
    this.buttons = Array.from(this.querySelectorAll("button"))
    this.changeEvent = new Event("change", {
      bubbles: true,
    })
    this.onInputChangeDebounced = Utility.debounce(this.onInputChange.bind(this));
    this.input.addEventListener("change", this.onInputChangeDebounced)
    this.buttons.forEach(button => button.addEventListener("click", this.onButtonClick.bind(this)))
  }
  connectedCallback() {
    this.updateButtonState()
  }
  onInputChange(event) {
    this.validateQtyRules(event)
  }
  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;
    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else if (this.input.value <= parseInt(this.input.max) || this.input.max === "") {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }
  async validateQtyRules(event) {
    this.updateButtonState()

    const target = event?.target || this.input;
    const inputValue = parseInt(target?.value ?? this.input.value, 10);
    const index = target?.dataset?.index || this.input.dataset.index;
    if (!Number.isFinite(inputValue) || !index) return

    this.setButtonsDisabled(true);
    try {
      await this.modules.cart.changeCartItem(index, inputValue);
    } finally {
      this.setButtonsDisabled(false);
      this.updateButtonState();
    }
  }

  updateButtonState() {
    const value = parseInt(this.input.value, 10)
    const minus = this.querySelector("[name='minus']")
    const plus = this.querySelector("[name='plus']")
    if (minus && this.input.min) {
      minus.classList.toggle("disabled", value <= parseInt(this.input.min, 10))
    }
    if (plus && this.input.max) {
      plus.classList.toggle("disabled", value >= parseInt(this.input.max, 10))
    }
    if (this.modules.cart.isFetching) {
      this.setButtonsDisabled(true);
    }
  }

  setButtonsDisabled(disabled) {
    this.buttons.forEach(button => {
      button.disabled = disabled;
    });
  }
}
customElements.define("quantity-input", QuantityInput);

class CartRemoveButton extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule])
    this.addEventListener("click", event => {
      event.preventDefault()
      this.modules.cart.changeCartItem(this.dataset.index, 0)
    })
  }
}
customElements.define("cart-remove-button", CartRemoveButton);

class SubscriptionWidget extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule]);
    this._handleSelectChange = this.handleSelectChange.bind(this);
  }

  connectedCallback() {
    this.select = this.querySelector("select");
    this.repeatOrderBtn = this.querySelector(".repeat-order-btn")
    this.subscriptionOptions = this.querySelector(".subscription-options")
    this.quantity = this.dataset.itemQty;
    this.select.addEventListener("change", this._handleSelectChange);
    
    this.repeatOrderBtn.addEventListener("click", this.selectDefaultPlan.bind(this));
  }

  disconnectedCallback() {
    this.select.removeEventListener("change", this._handleSelectChange);
  }

  async handleSelectChange(e) {
    const sellingPlanId = e.target.value;
    const index = e.target.dataset.index;
    const quantity = this.quantity;
    if (!index || !quantity) return;
    const planId = sellingPlanId === "one-time-purchase" ? null : sellingPlanId;
    await this.modules.cart.changeCartItem(index, quantity, planId);
  }

  selectDefaultPlan(){
    this.select.value = this.select[0].value
    this.select.dispatchEvent(
      new Event("change", { bubbles: true })
    );
  }
}

if (!customElements.get("subscription-widget")) customElements.define("subscription-widget", SubscriptionWidget);

class DatePicker extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule]);
    this._onButtonClick = this.onButtonClick.bind(this)
  }

  connectedCallback() {
    this.settings = window.calendarSettings || {};
    this.input = this.querySelector("input");
    this.button = this.querySelector("button");
    this.button.addEventListener('click', this._onButtonClick)
    this.initCalendar()
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this._onButtonClick)
  }

  onButtonClick(event) {
    event.preventDefault()
    this.input.click()
  }

  initCalendar() {
    let calendarInput = this.input;
    const settings = this.settings;
    const festiveDates = [];
    const modules = this.modules;
    if (settings.festiveDays && settings.festiveDays.length > 0) {
      settings.festiveDays.map((date) => {
        let dates = date.dates.split(",");
        dates = dates.map((d) => {
          festiveDates.push(d.trim());
          return d.trim();
        });
      });
    }

    calendarInput = flatpickr(calendarInput, {
      showMonths: window.innerWidth >= 690 ? 2 : 1,
      dateFormat: "d/m/Y",
      minDate: settings.minDate,
      maxDate: settings.maxDate,
      locale: {
        firstDayOfWeek: 1,
      },
      onDayCreate: function (dObj, dStr, fp, dayElem) {
        const date = dayjs(dayElem.dateObj);
        if (festiveDates && festiveDates.includes(date.format("DD/MM/YYYY"))) {
          const festiveDate = settings.festiveDays.find((d) => {
            return d.dates.includes(date.format("DD/MM/YYYY"));
          });

          if (festiveDate.icon.default) {
            const icon = `<img class="icon" src="${festiveDate.icon.default}" alt="Festive icon for ${festiveDate.Date}" />`;
            const iconSelected = `<img class="icon icon--selected" src="${festiveDate.icon.selected.length > 0 ? festiveDate.icon.selected : festiveDate.icon.default
              }" alt="Festive icon for ${festiveDate.Date}" />`;
            dayElem.innerHTML = icon + iconSelected + dayElem.innerHTML;
          }
        }
      },
      disable: [
        function (date) {
          const dateObj = dayjs(date);
          const excludedDays = settings.excludedDays?.map(Number);
          const excludedDates = settings.excludedDates;

          if (excludedDays?.includes(dateObj.get("day"))) {
            return true;
          }

          if (excludedDates?.includes(dateObj.format("DD/MM/YYYY"))) {
            return true;
          }
        },
      ],

      onChange: function () {
        if (calendarInput._input.value.length == 10) {
          modules.cart.updateDelivery(calendarInput._input.value, settings.festiveDays);
        }
        calendarInput.close();
      },
      

       onReady: function (selectedDates, dateStr, instance) {
        if (instance.calendarContainer.querySelector('.urgency-message')) {
          return;
        }

       const urgencyMessage = document.createElement('div');

        urgencyMessage.className = 'date-picker--message';
        urgencyMessage.innerHTML = window.calendarSettings.datePickerMessageHtml;

        instance.calendarContainer.appendChild(urgencyMessage);
      }


    });
  }

  resetDatepicker() {
    if (this.input) {
      this.input.value = "";
    }
  }
}
customElements.define("date-picker", DatePicker);

class OpenDrawer extends HTMLElement {
  constructor() {
    super()
    this._handleClick = this.handleClick.bind(this)
  }

  connectedCallback() {
    this.drawerName = this.getAttribute('drawer')

    this.addEventListener('click', this._handleClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick)
  }

  handleClick() {
    const drawerElement = document.querySelector(`[data-drawer="${this.drawerName}"]`)
    if (!drawerElement) return
    const drawerObj = new Drawer(drawerElement)
    drawerObj.open()
  }
}
customElements.define('open-drawer', OpenDrawer)

class CartNote extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule]);
    this._onCheckboxChange = this.onCheckboxChange.bind(this)
    this._onBlurTextarea = this.onBlurTextarea.bind(this)
  }

  connectedCallback() {
    this.checkbox = this.querySelector(`input[type="checkbox"]`)
    this.cartnoteEl = this.querySelector('.cart-note')
    this.textarea = this.querySelector(`textarea`)
    this.checkbox.addEventListener('change', this._onCheckboxChange)
    this.textarea.addEventListener('blur', this._onBlurTextarea)
  }

  disconnectedCallback() {
    this.checkbox?.removeEventListener('change', this._onCheckboxChange)
    this.textarea?.removeEventListener('blur', this._onBlurTextarea)
  }

  onBlurTextarea(event) {
    const message = event.target.value
    this.modules.cart.updateNote(this.textarea.name, message)
  }

  async onCheckboxChange(event) {
    const isExpand = event.target.checked
    if (!isExpand) {
      await this.modules.cart.updateNote(this.textarea.name, '')
    }
    this.cartnoteEl.classList.toggle('is-visible', isExpand)
  }
}
customElements.define('cart-note', CartNote)

class AgeConfirmation extends WiroHTMLRenderer {
  constructor() {
    super([WiroCartModule]);
    this._onCheckboxChange = this.onCheckboxChange.bind(this)
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="checkbox"]')
    this.input.addEventListener('change', this._onCheckboxChange)
  }

  disconnectedCallback() {
    this.input?.removeEventListener('change', this._onCheckboxChange)
  }

  async onCheckboxChange(event) {
    const { checked, name } = event.target
    if (!name) return
    const message = checked ? 'Yes' : ''
    await this.modules.cart.updateNote(name, message)
  }
}
customElements.define('age-confirmation', AgeConfirmation);


